import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "./App.css";
import MarketingSite from "./pages/MarketingSite";
import { AuthProvider } from "./portal/AuthContext";
import ProtectedRoute from "./portal/ProtectedRoute";
import PortalLayout from "./portal/PortalLayout";
import Login from "./portal/Login";
import ForgotPassword from "./portal/ForgotPassword";
import ResetPassword from "./portal/ResetPassword";
import Dashboard from "./portal/Dashboard";
import Employees from "./portal/Employees";
import EmployeeForm from "./portal/EmployeeForm";
import EmployeeDetail from "./portal/EmployeeDetail";
import Payroll from "./portal/Payroll";
import SalarySlip from "./portal/SalarySlip";
import Settings from "./portal/Settings";
import FieldTracker from "./portal/FieldTracker";
import Inventory from "./portal/Inventory";

function App() {
  return (
    <div className="App">
      <Toaster
        position="bottom-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "#0C1322",
            border: "1px solid rgba(255,255,255,0.1)",
            color: "#F8FAFC",
            borderRadius: 0,
            fontFamily: "IBM Plex Mono, monospace",
            fontSize: "13px",
          },
        }}
      />
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<MarketingSite />} />
            <Route path="/portal/login" element={<Login />} />
            <Route path="/portal/forgot-password" element={<ForgotPassword />} />
            <Route path="/portal/reset-password" element={<ResetPassword />} />
            <Route
              path="/portal"
              element={
                <ProtectedRoute>
                  <PortalLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="employees" element={<Employees />} />
              <Route path="employees/new" element={<EmployeeForm />} />
              <Route path="employees/:id" element={<EmployeeDetail />} />
              <Route path="employees/:id/edit" element={<EmployeeForm />} />
              <Route path="payroll" element={<Payroll />} />
              <Route path="payroll/:id/slip" element={<SalarySlip />} />
              <Route path="field" element={<FieldTracker />} />
              <Route path="inventory" element={<Inventory />} />
              <Route path="settings" element={<Settings />} />
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
